import { render, staticRenderFns } from "./ManageGlobalLocations.vue?vue&type=template&id=07be199f&"
import script from "./ManageGlobalLocations.vue?vue&type=script&lang=js&"
export * from "./ManageGlobalLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports